import api from "./api";

export const getNicheCategory = async () => {
  return await api.get(`/api/backlinks/niche_products`);
};
